var map = {
	"./amplify-amazon-button_5.entry.js": [
		8582,
		162,
		582
	],
	"./amplify-auth-container.entry.js": [
		7226,
		197
	],
	"./amplify-auth-fields_9.entry.js": [
		7581,
		581
	],
	"./amplify-authenticator.entry.js": [
		2762,
		162,
		762
	],
	"./amplify-button_3.entry.js": [
		1207,
		207
	],
	"./amplify-chatbot.entry.js": [
		7977,
		977
	],
	"./amplify-checkbox.entry.js": [
		3124,
		124
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		7477,
		162,
		477
	],
	"./amplify-container.entry.js": [
		5818,
		818
	],
	"./amplify-federated-buttons_2.entry.js": [
		4976,
		162,
		976
	],
	"./amplify-federated-sign-in.entry.js": [
		1219,
		219
	],
	"./amplify-form-field_4.entry.js": [
		7601,
		162,
		601
	],
	"./amplify-greetings.entry.js": [
		8197,
		162,
		578
	],
	"./amplify-icon-button.entry.js": [
		4697,
		697
	],
	"./amplify-icon.entry.js": [
		4100,
		100
	],
	"./amplify-link.entry.js": [
		1209,
		209
	],
	"./amplify-nav_2.entry.js": [
		8501,
		162,
		501
	],
	"./amplify-photo-picker.entry.js": [
		2620,
		620
	],
	"./amplify-picker.entry.js": [
		9211,
		211
	],
	"./amplify-radio-button_3.entry.js": [
		9981,
		162,
		981
	],
	"./amplify-s3-album.entry.js": [
		3577,
		797,
		577
	],
	"./amplify-s3-image-picker.entry.js": [
		1574,
		797,
		574
	],
	"./amplify-s3-image.entry.js": [
		3999,
		797,
		999
	],
	"./amplify-s3-text-picker.entry.js": [
		1234,
		797,
		234
	],
	"./amplify-s3-text.entry.js": [
		5379,
		797,
		379
	],
	"./amplify-select-mfa-type.entry.js": [
		1363,
		363
	],
	"./amplify-sign-in-button.entry.js": [
		3859,
		859
	],
	"./amplify-tooltip.entry.js": [
		3401,
		782
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3120;
module.exports = webpackAsyncContext;